import React, { useState } from 'react';
import { InfoIcon } from 'lucide-react';
interface InfoTooltipProps {
  content: string;
}
export function InfoTooltip({
  content
}: InfoTooltipProps) {
  const [isVisible, setIsVisible] = useState(false);
  return <div className="relative ml-1.5 inline-block" data-id="element-2884">
      <button type="button" className="text-gray-400 hover:text-gray-500 focus:outline-none" onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)} onFocus={() => setIsVisible(true)} onBlur={() => setIsVisible(false)} data-id="element-2885">
        <InfoIcon size={14} data-id="element-2886" />
      </button>
      {isVisible && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-48 p-2 bg-gray-800 text-white text-xs rounded shadow-lg z-10" data-id="element-2887">
          {content}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-2 h-2 bg-gray-800 rotate-45" data-id="element-2888"></div>
        </div>}
    </div>;
}